var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { NullLogger, LogLevel } from '../logger';
import { Compressor } from './util/Compressor';
import { Encoding } from './util/Encoding';
import { LOGGER_NAME } from '../common/constants';
export var ConnectionState;
(function (ConnectionState) {
    ConnectionState[ConnectionState["DISCONNECTED"] = 0] = "DISCONNECTED";
    ConnectionState[ConnectionState["CONNECTING"] = 1] = "CONNECTING";
    ConnectionState[ConnectionState["AUTHENTICATED"] = 2] = "AUTHENTICATED";
})(ConnectionState || (ConnectionState = {}));
export var DeploymentStage;
(function (DeploymentStage) {
    DeploymentStage[DeploymentStage["production"] = 40] = "production";
    DeploymentStage[DeploymentStage["preproduction"] = 35] = "preproduction";
    DeploymentStage[DeploymentStage["show"] = 30] = "show";
    DeploymentStage[DeploymentStage["testing"] = 20] = "testing";
})(DeploymentStage || (DeploymentStage = {}));
export var DefaultHosts;
(function (DefaultHosts) {
    DefaultHosts["production"] = "frontgate.factsetdigitalsolutions.com";
    DefaultHosts["show"] = "frontgate.show.factsetdigitalsolutions.com";
})(DefaultHosts || (DefaultHosts = {}));
var AbstractFrontgateConnection = (function () {
    function AbstractFrontgateConnection(auth, options) {
        this.reconnectDelays = [1000, 2000, 4000, 8000, 16000, 32000];
        this.reconnectCounter = 0;
        this.lastAuthMSG = '';
        this.onMessage = null;
        this.onClose = null;
        this.onError = null;
        this.onAuthentication = null;
        this.onCleanupRequests = null;
        this.onCleanupSubscriptions = null;
        this.onClearPendingSubscription = null;
        this.onReceiveTimeout = null;
        this.restartSubscriptions = null;
        this.options = Object.assign({}, AbstractFrontgateConnection.DEFAULT_OPTIONS, options);
        this.auth = auth;
        this.state = ConnectionState.DISCONNECTED;
        this.logger = this.options.logger;
        this.timestampOfLastMessageSent = null;
        this.jobId = 0;
        this.peerInfo = null;
        this.compressor = new Compressor();
        this.keepAliveIntervalHandle = null;
        this.logger.setLevel(this.options.loglevel);
        if (!Encoding.isSupportedEncoding(this.options.encoding)) {
            throw new Error("Unknown or unsupported encoding: " + this.options.encoding);
        }
        this.messageProcessors = {};
        this.setMessageProcessor('Foundation::LoadNotificationMessage', this.handleLoadNotificationMessage.bind(this));
        this.setMessageProcessor('Foundation::KeepAliveMessage', this.handleKeepAliveMessage.bind(this));
        this.setMessageProcessor('Foundation::DisconnectionMessage', this.handleDisconnectionMessage.bind(this));
        this.setMessageProcessor('Foundation::AuthenticationByTokenResponse', this.handleAuthenticationByTokenResponse.bind(this));
        this.setMessageProcessor('Foundation::AuthenticationResponse', this.handleAuthenticationResponse.bind(this));
        this.setMessageProcessor('Foundation::ConfigurationResponse', this.handleConfigurationResponse.bind(this));
        this.setMessageProcessor('Foundation::TransportLayerClientConfigurationResponse', this.handleTransportLayerClientConfigurationResponse.bind(this));
        this.setMessageProcessor('Foundation::SubscriptionLossMessage', this.handleSubscriptionLossMessage.bind(this));
    }
    AbstractFrontgateConnection.prototype.setMessageProcessor = function (messageName, messageProcessor) {
        this.messageProcessors[messageName] = messageProcessor;
    };
    AbstractFrontgateConnection.prototype.close = function () {
        return __awaiter(this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.isAuthenticated()) {
                            return [2, Promise.reject(new Error('Connection is not open.'))];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 5]);
                        return [4, this.sendDisconnectionMessage()];
                    case 2: return [2, _a.sent()];
                    case 3:
                        error_1 = _a.sent();
                        return [4, this.handleClose(error_1)];
                    case 4:
                        _a.sent();
                        return [2, Promise.resolve()];
                    case 5: return [2];
                }
            });
        });
    };
    AbstractFrontgateConnection.prototype.setPeerInfo = function (peerInfo) {
        this.peerInfo = Object.assign({}, this.peerInfo, peerInfo);
    };
    AbstractFrontgateConnection.prototype.isAuthenticated = function () {
        return this.state === ConnectionState.AUTHENTICATED;
    };
    AbstractFrontgateConnection.prototype.isInitialized = function () {
        return this.state === ConnectionState.CONNECTING;
    };
    AbstractFrontgateConnection.prototype.handleLoadNotificationMessage = function (msg) {
        if (this.peerInfo) {
            this.peerInfo.loadStatus = msg.load;
        }
        return false;
    };
    AbstractFrontgateConnection.prototype.handleKeepAliveMessage = function () {
        return false;
    };
    AbstractFrontgateConnection.prototype.handleDisconnectionMessage = function (msg) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.handleClose("DisconnectionMessage received: '" + msg.details)];
                    case 1:
                        _a.sent();
                        if (this.onClose) {
                            this.onClose(msg.details);
                        }
                        return [2];
                }
            });
        });
    };
    AbstractFrontgateConnection.prototype.handleAuthenticationByTokenResponse = function () {
        var _this = this;
        this.state = ConnectionState.AUTHENTICATED;
        var INTERVAL_TIMER = 1000;
        this.keepAliveIntervalHandle = setInterval(function () { return _this.sendKeepAliveMessage(); }, INTERVAL_TIMER);
        if (this.onAuthentication) {
            this.onAuthentication();
        }
        return true;
    };
    AbstractFrontgateConnection.prototype.handleAuthenticationResponse = function () {
        this.lastAuthMSG = 'Foundation::AuthenticationResponse';
        return true;
    };
    AbstractFrontgateConnection.prototype.handleConfigurationResponse = function () {
        if (this.lastAuthMSG === 'Foundation::AuthenticationResponse') {
            this.lastAuthMSG = 'Foundation::ConfigurationResponse';
        }
        return true;
    };
    AbstractFrontgateConnection.prototype.handleTransportLayerClientConfigurationResponse = function () {
        var _this = this;
        if (this.lastAuthMSG === 'Foundation::ConfigurationResponse') {
            this.lastAuthMSG = 'Foundation::TransportLayerClientConfigurationResponse';
            this.state = ConnectionState.AUTHENTICATED;
            var INTERVAL_TIMER = 1000;
            this.keepAliveIntervalHandle = setInterval(function () { return _this.sendKeepAliveMessage(); }, INTERVAL_TIMER);
            if (this.onAuthentication) {
                this.onAuthentication();
            }
        }
        return true;
    };
    AbstractFrontgateConnection.prototype.handleReceiveTimeout = function () {
        clearTimeout(this.messageReceiveTimeout);
        if (this.onReceiveTimeout) {
            this.onReceiveTimeout();
        }
    };
    AbstractFrontgateConnection.prototype.resetReceiveTimeout = function () {
        var _this = this;
        if (!this.peerInfo || !this.peerInfo.maximumIdleInterval) {
            return;
        }
        var timeoutInMs = this.peerInfo.maximumIdleInterval / 1000 * 2;
        if (this.messageReceiveTimeout) {
            clearTimeout(this.messageReceiveTimeout);
        }
        this.messageReceiveTimeout = setTimeout(function () { return _this.handleReceiveTimeout(); }, timeoutInMs);
    };
    AbstractFrontgateConnection.prototype.handleSubscriptionLossMessage = function (msg) {
        this.onClearPendingSubscription(msg.header.id_job);
    };
    AbstractFrontgateConnection.prototype.handleStandardMessage = function (msg) {
        if (this.onMessage) {
            this.onMessage(msg);
        }
        return true;
    };
    AbstractFrontgateConnection.prototype.handleMessage = function (msg) {
        if (!msg || !msg.Message) {
            return;
        }
        this.resetReceiveTimeout();
        var messageHandler = this.messageProcessors[msg.Message];
        if (messageHandler !== undefined) {
            if (!messageHandler(msg)) {
                return;
            }
        }
        else {
            this.handleStandardMessage(msg);
        }
        return msg;
    };
    AbstractFrontgateConnection.prototype.handleClose = function (info) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var isDisconnectMessage, _loop_1, this_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.logger.debug("Handling close type: " + ((_a = info === null || info === void 0 ? void 0 : info.constructor) === null || _a === void 0 ? void 0 : _a.name), info);
                        this.state = ConnectionState.DISCONNECTED;
                        if (this.keepAliveIntervalHandle) {
                            clearInterval(this.keepAliveIntervalHandle);
                            this.keepAliveIntervalHandle = null;
                        }
                        this.compressor.reset();
                        this.peerInfo = null;
                        if (this.messageReceiveTimeout) {
                            clearTimeout(this.messageReceiveTimeout);
                            this.messageReceiveTimeout = null;
                        }
                        if (this.onCleanupRequests) {
                            this.onCleanupRequests();
                        }
                        if (!this.shouldRestartSubscriptions) {
                            if (this.onCleanupSubscriptions) {
                                this.onCleanupSubscriptions();
                            }
                        }
                        isDisconnectMessage = typeof info === 'string' && info.includes('DisconnectionMessage');
                        if (isDisconnectMessage) {
                            this.logger.debug('Disconnect message received. Preventing reconnect. Potential authentication failure.');
                            this.options.shouldReconnectOnConnectionLoss = false;
                        }
                        if (!this.options.shouldReconnectOnConnectionLoss) return [3, 4];
                        _loop_1 = function () {
                            var lastDelayIndex, delay_1, reconnectError_1;
                            return __generator(this, function (_c) {
                                switch (_c.label) {
                                    case 0:
                                        this_1.logger.debug("Trying to reconnect... " + (this_1.reconnectCounter ? this_1.reconnectCounter + ' attempts' : ''));
                                        this_1.compressor.reset();
                                        this_1.peerInfo = null;
                                        this_1.state = ConnectionState.DISCONNECTED;
                                        _c.label = 1;
                                    case 1:
                                        _c.trys.push([1, 5, , 6]);
                                        lastDelayIndex = this_1.reconnectDelays.length - 1;
                                        delay_1 = this_1.reconnectDelays[this_1.reconnectCounter]
                                            ? this_1.reconnectDelays[this_1.reconnectCounter]
                                            : this_1.reconnectDelays[lastDelayIndex];
                                        this_1.logger.debug("Waiting " + delay_1 + " ms");
                                        return [4, new Promise(function (resolve) { return setTimeout(resolve, delay_1); })];
                                    case 2:
                                        _c.sent();
                                        this_1.reconnectCounter++;
                                        if (!!this_1.isInitialized()) return [3, 4];
                                        return [4, this_1.open()];
                                    case 3:
                                        _c.sent();
                                        this_1.restartSubscriptions();
                                        _c.label = 4;
                                    case 4: return [3, 6];
                                    case 5:
                                        reconnectError_1 = _c.sent();
                                        this_1.logger.error('Failed to reconnect', reconnectError_1);
                                        return [3, 6];
                                    case 6: return [2];
                                }
                            });
                        };
                        this_1 = this;
                        _b.label = 1;
                    case 1:
                        if (!!this.isAuthenticated()) return [3, 3];
                        return [5, _loop_1()];
                    case 2:
                        _b.sent();
                        return [3, 1];
                    case 3:
                        this.reconnectCounter = 0;
                        return [3, 5];
                    case 4:
                        if (this.onClose) {
                            this.onClose(info);
                        }
                        this.onMessage = null;
                        this.onClose = null;
                        this.onAuthentication = null;
                        this.onError = null;
                        _b.label = 5;
                    case 5: return [2];
                }
            });
        });
    };
    AbstractFrontgateConnection.prototype.handleWsError = function (handleWsError) {
        this.logger.error('WebSocket Error: ', handleWsError);
        if (this.onError) {
            this.onError(handleWsError);
        }
    };
    AbstractFrontgateConnection.prototype.preSubmit = function (msg) {
        if (msg && msg.Message) {
            var jobId = this.returnAndAssignJobIdToMessage(msg);
            this.logger.trace('PreSubmit', { message: msg.Message, jobId: jobId });
            return jobId;
        }
        if (msg) {
            throw new TypeError('Expected message type. Must be JSON message object or Array of JSON message objects');
        }
    };
    AbstractFrontgateConnection.prototype.sendKeepAliveMessage = function () {
        return __awaiter(this, void 0, void 0, function () {
            var msSinceLastMsg, meanIdleInterval, keepAliveNeeded, request;
            return __generator(this, function (_a) {
                msSinceLastMsg = Date.now() - this.timestampOfLastMessageSent;
                meanIdleInterval = this.options.maximum_idle_interval / 1000 / 2;
                keepAliveNeeded = this.timestampOfLastMessageSent > 0 && msSinceLastMsg > meanIdleInterval;
                if (!keepAliveNeeded) {
                    return [2];
                }
                request = {
                    Message: 'Foundation::KeepAliveMessage',
                    Version: 2
                };
                return [2, this.submit(request)];
            });
        });
    };
    AbstractFrontgateConnection.prototype.sendDisconnectionMessage = function (reason, code) {
        if (reason === void 0) { reason = 'client shutdown'; }
        if (code === void 0) { code = 64; }
        return __awaiter(this, void 0, void 0, function () {
            var request;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = {
                            Message: 'Foundation::DisconnectionMessage',
                            Version: 3,
                            reason: {
                                value: code
                            },
                            details: reason
                        };
                        return [4, this.submit(request)];
                    case 1:
                        _a.sent();
                        return [4, this.handleClose('Disconnected by User.')];
                    case 2:
                        _a.sent();
                        return [2];
                }
            });
        });
    };
    AbstractFrontgateConnection.prototype.returnAndAssignJobIdToMessage = function (message) {
        if (typeof (message) !== 'object') {
            throw new TypeError("expected object, not " + typeof (message));
        }
        if (typeof (message.Message) === 'undefined') {
            throw new TypeError('expected object to have a \'Message\' member');
        }
        if (!message.Message.match('Request$')) {
            return null;
        }
        if (typeof (message.header) === 'undefined') {
            return null;
        }
        if (!message.header.id_job) {
            this.jobId = (this.jobId >= Number.MAX_SAFE_INTEGER) ? 1 : this.jobId + 1;
            message.header.id_job = this.jobId;
        }
        return message.header.id_job;
    };
    AbstractFrontgateConnection.DEFAULT_OPTIONS = {
        payload_content: 'foundation',
        deployment_stage: DeploymentStage.show,
        logger: NullLogger.getLogger(LOGGER_NAME),
        loglevel: LogLevel.WARN,
        maximum_idle_interval: 45000000,
        host: DefaultHosts.show,
        port: 443,
        path_prefix: '',
        encoding: 'jsjsonc-v2',
        split_authentication_token_second_factor: undefined,
        shouldReconnectOnConnectionLoss: true
    };
    return AbstractFrontgateConnection;
}());
export { AbstractFrontgateConnection };
//# sourceMappingURL=AbstractFrontgateConnection.js.map